import React, { useState, useEffect, useRef } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import { GrFormCheckmark } from "react-icons/gr";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../Config";

// ── Defined OUTSIDE component so ref is never lost on re-render ───────────────
const ImgPlaceholder = ({ size = 60 }) => (
  <div className="flex flex-col items-center justify-center h-full text-gray-500">
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect
        x="2"
        y="4"
        width="16"
        height="13"
        rx="2"
        stroke="black"
        strokeWidth="1.5"
      />
      <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
      <path d="M2 13L6 9L11 14L14 11L18 15" stroke="black" strokeWidth="1.5" />
      <circle
        cx="17"
        cy="17"
        r="6"
        fill="white"
        stroke="black"
        strokeWidth="1.5"
      />
      <path d="M17 14V20M14 17H20" stroke="black" strokeWidth="1.5" />
    </svg>
    <span className="mt-2">Add Only Webp img</span>
  </div>
);

const ImageBox = ({
  imgKey,
  imgSrc,
  onOpen,
  onUpload,
  inputRef,
  className = "",
  style = {},
}) => (
  <div
    className={`border-2 border-gray-300 cursor-pointer overflow-hidden relative ${className}`}
    style={style}
    onClick={() => onOpen(imgKey)}
  >
    {imgSrc ? (
      <img src={imgSrc} alt="Uploaded" className="w-full h-full object-cover" />
    ) : (
      <ImgPlaceholder />
    )}
    <input
      type="file"
      accept="image/webp"
      ref={inputRef}
      onChange={(e) => onUpload(e, imgKey)}
      className="hidden"
    />
  </div>
);

const BrochureElementor = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isSaving, setIsSaving] = useState(false);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });
  const [formData, setFormData] = useState({
    villaname: "",
    toptext: "",
    location: "",
    villadesc1: "",
    villadesc2: "",
    curatetitle1: "",
    curatedesc1: "",
    curatetitle2: "",
    curatedesc2: "",
    curatetitle3: "",
    curatedesc3: "",
    curatetitle4: "",
    curatedesc4: "",
    curatetitle5: "",
    curatedesc5: "",
    thetitle: "",
    thetitleprefix: "",
    villatitleprefix: "",
    livingtitle: "",
    livingdesc1: "",
    livingdesc2: "",
    kitchentitle: "",
    pooltitle: "",
    thebedtitle: "",
    bedroomtitle: "",
    beddesc1: "",
    beddesc2: "",
    commonareas: "",
    destination: "",
    destinationdesc: "",
    traveltitle: "",
    travellink: "",
    service: "",
    servicedesc: "",
    conciergetitle: "",
    conciergelink: "",
    nature: "",
    naturedesc1: "",
    naturedesc2: "",
    naturedesc3: "",
  });

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) setIsSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [images, setImages] = useState({});
  const fileInputRefs = useRef({});

  const handleImageUpload = (e, key) => {
    const file = e.target.files[0];
    if (file && file.type === "image/webp") {
      setImages((prev) => ({ ...prev, [key]: URL.createObjectURL(file) }));
    } else {
      alert("Only .webp images are allowed");
    }
  };

  const openFilePicker = (key) => {
    if (fileInputRefs.current[key]) fileInputRefs.current[key].click();
  };

  const [activeField, setActiveField] = useState(null);

  // Amenities
  const [showPopup, setShowPopup] = useState(false);
  const [, setSearchActive] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [tempSelected, setTempSelected] = useState([]);
  const [error, setError] = useState("");
  const [amenitiesList, setAmenitiesList] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/getAmenities`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const formatted = data.data.map((item) => ({
            id: item.id,
            name: item.name,
            imgSrc: item.url,
          }));
          setAmenitiesList(formatted);
        }
      })
      .catch((err) => console.error("Failed to load amenities", err));
  }, []);

  const filteredAmenities = amenitiesList.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()),
  );

  const handleSelect = (item) => {
    const exists = tempSelected.find((a) => a.id === item.id);
    if (exists) {
      setTempSelected(tempSelected.filter((a) => a.name !== item.name));
    } else {
      if (tempSelected.length < 20) setTempSelected([...tempSelected, item]);
    }
  };

  const handleOk = () => {
    if (tempSelected.length === 0) {
      setError("You have to select at least 1 amenity");
      return;
    }
    setSelectedAmenities(tempSelected);
    setShowPopup(false);
    setSearchActive(false);
    setError("");
  };

  const chunkAmenities = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size)
      result.push(arr.slice(i, i + size));
    return result;
  };

  const pages = chunkAmenities(selectedAmenities, 10);

  const page2Ref = useRef(null);

  useEffect(() => {
    const currentRef = page2Ref.current;
    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setTimeout(() => setShowPopup(true), 1000);
          observerInstance.unobserve(entry.target);
        }
      },
      { threshold: 0.6 },
    );
    if (currentRef) observer.observe(currentRef);
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  // const handleCancel = () => {
  //   setTempSelected(selectedAmenities);
  //   setShowPopup(false);
  //   setError("");
  // };

  const BottomLogo = () => (
    <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2">
      <div className="flex justify-center items-center space-x-4">
        <div className="w-12 h-[1px] bg-gray-400"></div>
        <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
          <img
            src="https://zorbastays.com/ZORBA_logo_iconGreen.webp"
            alt="logo"
            className="w-8 h-5 brightness-0"
          />
        </div>
        <div className="w-12 h-[1px] bg-gray-400"></div>
      </div>
    </div>
  );

  // ── IMAGE KEYS (matching DB columns without img_ prefix) ─────────────────
  // const IMAGE_KEYS = [
  //   "page1",
  //   "page3",
  //   "page5_1",
  //   "page5_2",
  //   "page5_3",
  //   "page6",
  //   "page7_1",
  //   "page7_2",
  //   "page8",
  //   "page9_1",
  //   "page9_2",
  //   "page10_1",
  //   "page10_2",
  //   "page11_1",
  //   "page11_2",
  //   "page11_3",
  //   "page12_1",
  //   "page12_2",
  //   "page12_3",
  //   "page13_1",
  //   "page13_2",
  //   "page13_3",
  //   "page14_1",
  //   "page14_2",
  //   "page15_1",
  //   "page15_2",
  //   "page16_1",
  //   "page16_2",
  //   "page17_1",
  //   "page17_2",
  //   "page18_1",
  //   "page18_2",
  //   "page18_3",
  //   "page19_1",
  //   "page19_2",
  //   "page20_1",
  //   "page20_2",
  // ];
  const REQUIRED_IMAGE_KEYS = [
    "page1",
    "page3",
    "page5_1",
    "page5_2",
    "page5_3",
    "page6",
    "page7_1",
    "page7_2",
    "page8",
    "page9_1",
    "page9_2",
  ];

  const OPTIONAL_IMAGE_KEYS = [
    "page10_1",
    "page10_2",
    "page11_1",
    "page11_2",
    "page11_3",
    "page12_1",
    "page12_2",
    "page12_3",
    "page13_1",
    "page13_2",
    "page13_3",
    "page14_1",
    "page14_2",
    "page15_1",
    "page15_2",
    "page16_1",
    "page16_2",
    "page17_1",
    "page17_2",
    "page18_1",
    "page18_2",
    "page18_3",
    "page19_1",
    "page19_2",
    "page20_1",
    "page20_2",
  ];

  //now saving with null data
  const handleSave = async () => {
    // ─── All validation removed ─────────────────────────────────────
    // Empty fields, amenities, and missing images checks removed intentionally
    // Pages with null data will display with fallback content in the brochure
    if (!formData.villaname || formData.villaname.trim() === "") {
      alert("Please enter a villa name.");
      return;
    }

    setIsSaving(true);
    try {
      // ─── Step 1: Upload images one by one ──────────────────────
      const imageurls = {};
      const allStaticKeys = [...REQUIRED_IMAGE_KEYS, ...OPTIONAL_IMAGE_KEYS];

      for (const key of allStaticKeys) {
        const file = fileInputRefs.current[key]?.files?.[0];
        if (!file) continue;

        const fd = new FormData();
        fd.append("image", file);
        fd.append("key", key);

        const res = await fetch(`${API_URL}/uploadImage`, {
          method: "POST",
          body: fd,
        });
        const data = await res.json();
        if (!data.success) throw new Error(`Failed uploading ${key}`);
        imageurls[key] = data.url;
      }

      // ─── Step 2: Upload dynamic page images ────────────────────
      const layoutImageCount = { layout1: 2, layout2: 3, layout3: 3 };
      const allDynamicPages = [
        ...dynamicPages1.map((p) => ({ ...p, section: "afterBedroomGallery" })),
        ...dynamicPages2.map((p) => ({
          ...p,
          section: "afterBedroomGallery4",
        })),
      ];

      const dynamicPagesPayload = [];

      for (let pageIndex = 0; pageIndex < allDynamicPages.length; pageIndex++) {
        const page = allDynamicPages[pageIndex];
        const count = layoutImageCount[page.type] || 2;
        const uploadedImages = [];

        for (let imgIndex = 0; imgIndex < count; imgIndex++) {
          const frontendKey = `dyn_${page.id}_${imgIndex + 1}`;
          const file = fileInputRefs.current[frontendKey]?.files?.[0];
          if (!file) continue;

          const fd = new FormData();
          fd.append("image", file);
          fd.append("key", `dynamic_${pageIndex}_${imgIndex}`);

          const res = await fetch(`${API_URL}/uploadImage`, {
            method: "POST",
            body: fd,
          });
          const data = await res.json();
          if (!data.success) throw new Error(`Failed uploading dynamic image`);
          uploadedImages.push(data.url);
        }

        dynamicPagesPayload.push({
          layout: page.type,
          section: page.section,
          images: uploadedImages,
        });
      }

      // ─── Step 3: Submit text + image urls as JSON ───────────────
      const payload = {
        ...formData,
        amenity_ids: JSON.stringify(selectedAmenities.map((a) => a.id)),
        dynamic_pages: JSON.stringify(dynamicPagesPayload),
        image_urls: imageurls,
      };

      const res = await fetch(`${API_URL}/createBrochure`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.success) {
        alert("Brochure created successfully!");
        navigate("/PropertyBrochure");
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save brochure: " + error.message);
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    const confirmDiscard = window.confirm(
      "Do you want to discard the changes?",
    );

    if (confirmDiscard) {
      navigate("/PropertyBrochure");
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // layout page
  const [showLayoutPopup, setShowLayoutPopup] = useState(false);
  const [activeInsertSection, setActiveInsertSection] = useState(null);

  const [dynamicPages1, setDynamicPages1] = useState([]);
  const [dynamicPages2, setDynamicPages2] = useState([]);

  const openPopup = (section) => {
    setActiveInsertSection(section);
    setShowLayoutPopup(true);
  };

  const addLayoutPage = (layoutType) => {
    const newId = Date.now();
    if (activeInsertSection === "afterPage9") {
      setDynamicPages1([...dynamicPages1, { id: newId, type: layoutType }]);
    } else {
      setDynamicPages2([...dynamicPages2, { id: newId, type: layoutType }]);
    }
    setShowLayoutPopup(false);
  };

  const [editingPageId, setEditingPageId] = useState(null);

  const renderDynamicLayout = (page) => (
    <div key={page.id} className="mt-5">
      {page.type === "layout1" && (
        <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
          <div className="w-full h-full flex flex-col relative pt-16 px-1">
            <div className="flex flex-col space-y-6 w-full">
              <ImageBox
                imgKey={`dyn_${page.id}_1`}
                imgSrc={images[`dyn_${page.id}_1`]}
                onOpen={openFilePicker}
                onUpload={handleImageUpload}
                inputRef={(el) =>
                  (fileInputRefs.current[`dyn_${page.id}_1`] = el)
                }
                className="h-[450px]"
              />
              <ImageBox
                imgKey={`dyn_${page.id}_2`}
                imgSrc={images[`dyn_${page.id}_2`]}
                onOpen={openFilePicker}
                onUpload={handleImageUpload}
                inputRef={(el) =>
                  (fileInputRefs.current[`dyn_${page.id}_2`] = el)
                }
                className="h-[420px]"
              />
            </div>
          </div>
        </div>
      )}

      {page.type === "layout2" && (
        <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
          <div className="w-full h-full flex flex-col relative pt-10 px-1">
            <div className="flex flex-col space-y-4 w-full h-full pb-16">
              <ImageBox
                imgKey={`dyn_${page.id}_1`}
                imgSrc={images[`dyn_${page.id}_1`]}
                onOpen={openFilePicker}
                onUpload={handleImageUpload}
                inputRef={(el) =>
                  (fileInputRefs.current[`dyn_${page.id}_1`] = el)
                }
                className="w-full h-[450px]"
              />
              <div className="flex space-x-4 w-full h-[450px]">
                <ImageBox
                  imgKey={`dyn_${page.id}_2`}
                  imgSrc={images[`dyn_${page.id}_2`]}
                  onOpen={openFilePicker}
                  onUpload={handleImageUpload}
                  inputRef={(el) =>
                    (fileInputRefs.current[`dyn_${page.id}_2`] = el)
                  }
                  className="flex-1"
                />
                <ImageBox
                  imgKey={`dyn_${page.id}_3`}
                  imgSrc={images[`dyn_${page.id}_3`]}
                  onOpen={openFilePicker}
                  onUpload={handleImageUpload}
                  inputRef={(el) =>
                    (fileInputRefs.current[`dyn_${page.id}_3`] = el)
                  }
                  className="flex-1"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {page.type === "layout3" && (
        <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
          <div className="w-full h-full flex flex-col relative pt-10 px-1">
            <div className="flex flex-col space-y-4 w-full h-full pb-16">
              <ImageBox
                imgKey={`dyn_${page.id}_1`}
                imgSrc={images[`dyn_${page.id}_1`]}
                onOpen={openFilePicker}
                onUpload={handleImageUpload}
                inputRef={(el) =>
                  (fileInputRefs.current[`dyn_${page.id}_1`] = el)
                }
                className="w-full h-[450px]"
              />
              <div className="flex space-x-4 w-full items-start">
                <ImageBox
                  imgKey={`dyn_${page.id}_2`}
                  imgSrc={images[`dyn_${page.id}_2`]}
                  onOpen={openFilePicker}
                  onUpload={handleImageUpload}
                  inputRef={(el) =>
                    (fileInputRefs.current[`dyn_${page.id}_2`] = el)
                  }
                  className="flex-1 h-[300px]"
                />
                <ImageBox
                  imgKey={`dyn_${page.id}_3`}
                  imgSrc={images[`dyn_${page.id}_3`]}
                  onOpen={openFilePicker}
                  onUpload={handleImageUpload}
                  inputRef={(el) =>
                    (fileInputRefs.current[`dyn_${page.id}_3`] = el)
                  }
                  className="flex-1 h-[450px]"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  const handleLayoutChangeFromPopup = (layoutType) => {
    setDynamicPages1((prev) =>
      prev.map((p) =>
        p.id === editingPageId ? { ...p, type: layoutType } : p,
      ),
    );

    setDynamicPages2((prev) =>
      prev.map((p) =>
        p.id === editingPageId ? { ...p, type: layoutType } : p,
      ),
    );

    setShowLayoutPopup(false);
    setEditingPageId(null);
  };

  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Brochure Elementor
            </p>
          </div>
          <div className="flex gap-2 items-center"></div>
        </div>

        <div className="my-5">
          <div className="min-h-screen flex flex-col items-center gap-5 py-10 print:gap-0 print:py-0 print:bg-[#f8f7f6]">
            <style
              dangerouslySetInnerHTML={{
                __html: `
              @page { size: A4 portrait; margin: 0; }
              @media print {
                html, body { width: 210mm; margin: 0; padding: 0; height: auto !important;
                  -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                body { zoom: 100%; }
                .print-page { width: 210mm !important; min-height: 297mm !important;
                  page-break-after: always; break-after: page;
                  page-break-inside: avoid; break-inside: avoid; margin: 0 !important; }
                .print-page:last-of-type { page-break-after: auto !important; break-after: auto !important; }
                .shadow-md { box-shadow: none !important; }
              }
            `,
              }}
            />

            {/* ═══ PAGE 1 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative flex flex-col items-center p-12">
              <div className="absolute top-0 left-12 w-[1px] h-80 bg-gray-400"></div>
              <div className="absolute top-0 left-20 w-[1px] h-60 bg-gray-400"></div>

              <div className="mt-8 flex flex-col items-center">
                <img
                  src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public"
                  alt="House of Basho"
                  className="h-28 w-auto object-contain"
                />
              </div>

              <div className="mt-20 text-center">
                <input
                  type="text"
                  spellCheck={false}
                  placeholder="The Villa Name"
                  value={formData.villaname}
                  onChange={(e) => handleChange("villaname", e.target.value)}
                  onFocus={() => setActiveField("villaname")}
                  onBlur={() => setActiveField(null)}
                  maxLength={25}
                  className="text-4xl PlayfairDisplay text-gray-800 tracking-wide bg-transparent border border-transparent text-center focus:border-black outline-none duration-300 focus:ring-0"
                />
                {activeField === "villaname" && (
                  <p className="text-xs text-gray-500">
                    {(formData.villaname || "").length}/25
                  </p>
                )}
              </div>

              <div className="mt-20 w-full relative group px-4">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="ENTER TEXT..."
                    value={formData.toptext || ""}
                    onChange={(e) => handleChange("toptext", e.target.value)}
                    onFocus={() => setActiveField("toptext")}
                    onBlur={() => setActiveField(null)}
                    maxLength={60}
                    className="montserrat w-full py-2 pl-2 pr-4 text-xs tracking-widest uppercase text-right bg-transparent border border-transparent duration-300 focus:border-black focus:ring-0 outline-none"
                  />
                  {activeField === "toptext" && (
                    <p className="text-[10px] text-gray-500 text-right">
                      {(formData.toptext || "").length}/60
                    </p>
                  )}
                </div>

                <div
                  className="w-full aspect-[4/3] bg-transparent overflow-hidden cursor-pointer border-2 border-gray-300"
                  onClick={() => openFilePicker("page1")}
                >
                  {images.page1 ? (
                    <img
                      src={images.page1}
                      alt="Uploaded"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <ImgPlaceholder size={60} />
                  )}
                  <input
                    type="file"
                    accept="image/webp"
                    ref={(el) => (fileInputRefs.current["page1"] = el)}
                    onChange={(e) => handleImageUpload(e, "page1")}
                    className="hidden"
                  />
                </div>

                <div className="absolute -mt-3 right-0 transform z-10 w-full">
                  <input
                    type="text"
                    spellCheck={false}
                    placeholder="Add Location..."
                    value={formData.location || ""}
                    onChange={(e) => handleChange("location", e.target.value)}
                    onFocus={() => setActiveField("location")}
                    onBlur={() => setActiveField(null)}
                    maxLength={30}
                    className="windsong w-full mx-auto text-7xl text-gray-900 text-right outline-none bg-transparent border-b border-t-0 border-r-0 border-l-0 border-b-transparent focus:border-b-black duration-300 focus:ring-0 focus:outline-none"
                  />
                  {activeField === "location" && (
                    <p className="text-xs text-gray-500 text-right">
                      {(formData.location || "").length}/30
                    </p>
                  )}
                </div>
              </div>

              <div className="montserrat absolute bottom-3">
                <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
                  <a
                    href="https://zorbastays.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>www.zorbastays.com</span>
                  </a>
                  <span className="h-3 w-[1px] bg-gray-400"></span>
                  <a href="mailto:info@zorbastays.com">
                    <span>info@zorbastays.com</span>
                  </a>
                  <span className="h-3 w-[1px] bg-gray-400"></span>
                  <span>63552-31066, 98750-28066</span>
                </div>
              </div>
            </div>

            {/* ═══ PAGE 2 — AMENITIES ═══ */}
            <>
              {pages.length === 0 ? (
                <div
                  ref={page2Ref}
                  className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12"
                >
                  <div>
                    <p className="EBGaramond text-3xl text-gray-800 leading-tight">
                      The
                    </p>
                    <h2 className="PlayfairDisplay text-4xl text-gray-800 uppercase mt-2">
                      AMENITIES
                    </h2>
                  </div>
                  <div className="flex justify-center items-center mt-32">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowPopup(true);
                      }}
                      className="border px-8 py-3 rounded-md text-gray-700 hover:bg-gray-100"
                    >
                      + Add Amenities
                    </button>
                  </div>
                  <BottomLogo />
                </div>
              ) : (
                pages.map((page, pageIndex) => (
                  <div
                    key={pageIndex}
                    ref={page2Ref}
                    onClick={() => setShowPopup(true)}
                    className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-16 mb-10 cursor-pointer"
                  >
                    {pageIndex === 0 && (
                      <div>
                        <p className="EBGaramond text-3xl text-gray-800 leading-tight">
                          The
                        </p>
                        <h2 className="PlayfairDisplay text-4xl text-gray-800 uppercase mt-2">
                          AMENITIES
                        </h2>
                      </div>
                    )}
                    <div className="grid grid-cols-2 gap-y-12 mt-20">
                      {page.map((item, index) => (
                        <div
                          key={index}
                          className="flex items-center space-x-4"
                        >
                          <div className="w-24 h-24 flex items-center justify-center">
                            <img
                              src={item.imgSrc}
                              alt={item.name}
                              className="max-w-full max-h-full object-contain"
                            />
                          </div>
                          <p className="uppercase tracking-widest text-sm">
                            {item.name}
                          </p>
                        </div>
                      ))}
                    </div>
                    <BottomLogo />
                  </div>
                ))
              )}

              {showPopup && (
                <div className="fixed inset-0 bg-black/40 flex justify-center items-start pt-20 z-50">
                  <div className="bg-white max-w-5xl rounded-xl p-6 relative">
                    {selectedAmenities.length > 0 && (
                      <button
                        onClick={handleCancel}
                        className="absolute top-4 right-4 text-gray-400 hover:text-black"
                      >
                        <IoMdClose size={20} />
                      </button>
                    )}
                    <h2 className="text-2xl text-center font-semibold">
                      Amenities
                    </h2>
                    <p className="text-center text-gray-500 mb-2">
                      {tempSelected.length} selected
                    </p>
                    <input
                      type="text"
                      placeholder="Search amenities..."
                      value={search}
                      onFocus={() => setSearchActive(true)}
                      onChange={(e) => setSearch(e.target.value)}
                      className="w-full border rounded-lg px-4 py-3 mb-4 focus:border-black outline-none duration-300 focus:ring-0"
                    />
                    {error && (
                      <p className="text-red-500 text-sm text-center mb-3">
                        {error}
                      </p>
                    )}
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-h-[350px] overflow-y-auto overflow-hidden">
                      {filteredAmenities.map((item, index) => {
                        const isSelected = tempSelected.find(
                          (a) => a.name === item.name,
                        );
                        return (
                          <div
                            key={index}
                            onClick={() => handleSelect(item)}
                            className={`relative p-2 border rounded-lg cursor-pointer flex flex-col items-center w-40 h-40 ${isSelected ? "border-black bg-gray-100" : "border-gray-200"}`}
                          >
                            <div className="absolute top-2 right-2">
                              <div
                                className={`w-4 h-4 rounded-full flex items-center justify-center border ${isSelected ? "bg-black border-black" : "border-gray-400 bg-white"}`}
                              >
                                {isSelected && (
                                  <GrFormCheckmark className="text-white" />
                                )}
                              </div>
                            </div>
                            <div className="w-24 h-24 flex items-center justify-center">
                              <img
                                src={item.imgSrc}
                                alt={item.name}
                                className="max-w-full max-h-full object-contain"
                              />
                            </div>
                            <p className="text-xs mt-3 text-center tracking-wide">
                              {item.name}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                    <div className="flex justify-end mt-6 space-x-3">
                      <button
                        onClick={handleOk}
                        className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>

            {/* ═══ PAGE 3 ═══ */}
            <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
              <div className="mb-8 ml-1">
                <h1 className="EBGaramond text-3xl text-gray-800 leading-tight">
                  <input
                    type="text"
                    placeholder="The"
                    value={formData.thetitleprefix || ""}
                    onChange={(e) =>
                      handleChange("thetitleprefix", e.target.value)
                    }
                    onFocus={() => setActiveField("thetitleprefix")}
                    onBlur={() => setActiveField(null)}
                    maxLength={10}
                    className="EBGaramond text-3xl text-gray-800 bg-transparent leading-tight outline-none max-w-[60%] border border-transparent focus:border-black focus:ring-0 transition-all duration-300"
                  />
                </h1>
                <h2 className="PlayfairDisplay text-4xl text-gray-800 uppercase mt-2">
                  <input
                    type="text"
                    placeholder="Villa / Apartment"
                    value={formData.villatitleprefix || ""}
                    onChange={(e) =>
                      handleChange("villatitleprefix", e.target.value)
                    }
                    onFocus={() => setActiveField("villatitleprefix")}
                    onBlur={() => setActiveField(null)}
                    maxLength={20}
                    className="PlayfairDisplay text-4xl text-gray-800 uppercase -ml-2 w-96 bg-transparent resize-none p-2 border border-transparent outline-none focus:border-black transition-all duration-300 focus:ring-0"
                  />
                </h2>
                {/* <h1 className="EBGaramond text-3xl text-gray-800 leading-tight">
             <input
                    type="text"
                    placeholder="The"
                    value={formData.thetitle || ""}
                    onChange={(e) => handleChange("thetitle", e.target.value)}
                    onFocus={() => setActiveField("thetitle")}
                    onBlur={() => setActiveField(null)}
                    maxLength={10}
                    className="EBGaramond text-3xl text-gray-800 bg-transparent leading-tight outline-none max-w-[60%] 
                  border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                </h1> */}
                {/* <h2 className="PlayfairDisplay text-4xl text-gray-800 uppercase mt-2"> */}
                {/* <input
                  placeholder="Villa / Apartment"
                  value={formData.villadesc1 || ""}
                  onChange={(e) => handleChange("villadesc1", e.target.value)}
                  onFocus={() => setActiveField("villadesc1")}
                  onBlur={() => setActiveField(null)}
                  maxLength={20}
                  className="PlayfairDisplay text-4xl text-gray-800 uppercase -ml-2 w-96 bg-transparent resize-none p-2 border border-transparent outline-none focus:border-black transition-all duration-300 focus:ring-0"
                /> */}
                {/* </h2> */}
              </div>
              <div className="montserrat mt-6 w-full text-gray-600 tracking-wide text-[14px] leading-relaxed space-y-4">
                <div>
                  <textarea
                    placeholder="Start Writing..."
                    value={formData.villadesc1 || ""}
                    onChange={(e) => handleChange("villadesc1", e.target.value)}
                    onFocus={() => setActiveField("villadesc1")}
                    onBlur={() => setActiveField(null)}
                    maxLength={450}
                    rows={6}
                    className="w-full bg-transparent resize-none p-2 border border-transparent outline-none focus:border-black transition-all duration-300 focus:ring-0"
                  />
                  {activeField === "villadesc1" && (
                    <p className="text-xs text-gray-500 text-right">
                      {(formData.villadesc1 || "").length}/450
                    </p>
                  )}
                </div>
                <div>
                  <textarea
                    placeholder="Start Writing..."
                    value={formData.villadesc2 || ""}
                    onChange={(e) => handleChange("villadesc2", e.target.value)}
                    onFocus={() => setActiveField("villadesc2")}
                    onBlur={() => setActiveField(null)}
                    maxLength={350}
                    rows={5}
                    className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:border-black focus:ring-0 transition-all duration-300"
                  />
                  {activeField === "villadesc2" && (
                    <p className="text-xs text-gray-500 text-right">
                      {(formData.villadesc2 || "").length}/350
                    </p>
                  )}
                </div>
              </div>

              <div
                className="absolute left-12 right-12 h-[430px] z-20 bottom-[110px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                onClick={() => openFilePicker("page3")}
              >
                {images.page3 ? (
                  <img
                    src={images.page3}
                    alt="Uploaded"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <ImgPlaceholder />
                )}
                <input
                  type="file"
                  accept="image/webp"
                  ref={(el) => (fileInputRefs.current["page3"] = el)}
                  onChange={(e) => handleImageUpload(e, "page3")}
                  className="hidden"
                />
              </div>
              <div className="absolute left-8 w-28 h-28 opacity-20 grayscale z-20 bottom-[19px]">
                <img
                  src="https://zorbastays.com/android-chrome-512x512.png"
                  alt="Logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            {/* ═══ PAGE 4 ═══ */}
            {/* <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative">
              <div className="w-full h-full flex flex-col pt-10 px-16 relative">
                <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-20 -ml-5">
                  The way we curate.
                </h2>
                <div className="relative w-full flex-1">
                  <div className="absolute -top-16 mt-4 -right-5 inset-0 flex justify-center pointer-events-none">
                    <img
                      src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3ea0d39f-9e34-4305-7ea0-07304c880a00/public"
                      alt="timeline"
                      className="opacity-60 w-auto h-[750px] object-contain"
                    />
                  </div>
                  <div className="relative z-10 flex flex-col space-y-3">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <div
                        key={n}
                        className={`max-w-[295px] 
                        ${
                          n === 1
                            ? "-ml-6 self-start"
                            : n === 2
                              ? "w-full self-end mr-20 relative -top-24 max-w-[290px]"
                              : n === 3
                                ? "w-full self-end mr-10 relative -top-14 max-w-[310px]"
                                : n === 4
                                  ? "w-full self-start relative -top-16 max-w-[300px]"
                                  : n === 5
                                    ? "w-full self-end relative -top-16 max-w-[310px]"
                                    : ""
                        }`}
                      >
                        <textarea
                          placeholder="Title..."
                          spellCheck={false}
                          value={formData[`curateTitle${n}`] || ""}
                          onChange={(e) =>
                            handleChange(`curateTitle${n}`, e.target.value)
                          }
                          onFocus={() => setActiveField(`curateTitle${n}`)}
                          onBlur={() => setActiveField(null)}
                          maxLength={50}
                          className="PlayfairDisplay text-xl text-gray-800 bg-transparent outline-none w-full resize-none leading-tight overflow-hidden border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                        />
                        {activeField === `curateTitle${n}` && (
                          <p className="text-xs text-gray-500">
                            {(formData[`curateTitle${n}`] || "").length}/50
                          </p>
                        )}
                        <textarea
                          placeholder="Start Writing..."
                          value={formData[`curateDesc${n}`] || ""}
                          onChange={(e) =>
                            handleChange(`curateDesc${n}`, e.target.value)
                          }
                          onFocus={() => setActiveField(`curateDesc${n}`)}
                          onBlur={() => setActiveField(null)}
                          maxLength={130}
                          rows={4}
                          className="montserrat text-[13px] text-gray-800 leading-relaxed tracking-wide bg-transparent outline-none w-full resize-none focus:ring-0 border border-transparent focus:border-black transition-all duration-300"
                        />
                        {activeField === `curateDesc${n}` && (
                          <p className="text-xs text-gray-500 text-right">
                            {(formData[`curateDesc${n}`] || "").length}/130
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="absolute -bottom-10 left-0 w-full text-center">
                  <a
                    href="https://zorbastays.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="text-[15px] tracking-[0.1em] text-gray-500">
                      www.zorbastays.com
                    </span>
                  </a>
                </div>
              </div>
            </div> */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative overflow-hidden font-serif">
              <div className="w-full h-full flex flex-col pt-10 px-20 relative">
                <h2 className="text-[42px] PlayfairDisplay text-gray-800 mb-10 tracking-tight">
                  The way we curate.
                </h2>

                <div className="relative flex-1">
                  <div className="absolute inset-0 flex justify-center items-start pointer-events-none">
                    <img
                      src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3ea0d39f-9e34-4305-7ea0-07304c880a00/public"
                      alt="timeline"
                      className="opacity-50 w-full h-auto max-h-[750px] object-contain"
                    />
                  </div>

                  <div className="relative h-full w-full">
                    {/* Block 1 */}
                    <div className="absolute top-[30px] left-[-10px] w-[200px]">
                      <h3 className="PlayfairDisplay text-[22px] text-gray-900 leading-[1.2] mb-2">
                        We Choose with Care
                      </h3>

                      <p className="montserrat text-[14px] text-gray-700 leading-[1.55] tracking-wide">
                        Every Zorba stay is personally verified for its design,
                        service, and sense of place.
                      </p>
                    </div>

                    {/* Block 2 */}
                    <div className="absolute top-[155px] right-[70px] w-[250px]">
                      <h3 className="PlayfairDisplay text-[22px] text-gray-900 leading-[1.2] mb-2">
                        We Understand Your
                        <br />
                        “Why” Before the “Where”
                      </h3>

                      <p className="montserrat text-[14px] text-gray-700 leading-[1.55] tracking-wide">
                        Every journey begins with intent. We craft stays that
                        reflect your purpose, your people, and the memories you
                        seek to create.
                      </p>
                    </div>

                    {/* Block 3 */}
                    <div className="absolute top-[410px] right-[95px] w-[270px]">
                      <h3 className="PlayfairDisplay text-[22px] text-gray-900 leading-[1.2] mb-2">
                        We’re Your Constant
                        <br />
                        Point of Support
                      </h3>

                      <p className="montserrat text-[14px] text-gray-700 leading-[1.55] tracking-wide">
                        From the first conversation to your final day, our team
                        ensures every detail flows seamlessly.
                      </p>
                    </div>

                    {/* Block 4 */}
                    <div className="absolute top-[550px] left-[-20px] w-[260px]">
                      <h3 className="PlayfairDisplay text-[22px] text-gray-900 leading-[1.2] mb-2">
                        We Bring Access, Not
                        <br />
                        Aggregation
                      </h3>

                      <p className="montserrat text-[14px] text-gray-700 leading-[1.55] tracking-wide">
                        Our collection opens doors to stays and experiences you
                        won’t find online, offered through trust and discovery.
                      </p>
                    </div>

                    {/* Block 5 */}
                    <div className="absolute top-[750px] right-[10px] w-[250px]">
                      <h3 className="PlayfairDisplay text-[22px] text-gray-900 leading-[1.2] mb-2">
                        Beyond Travel —
                        <br />
                        We Stay in Touch
                      </h3>

                      <p className="montserrat text-[14px] text-gray-700 leading-[1.55] tracking-wide">
                        We stay connected beyond your travels — inspiring your
                        next journey with new destinations and discoveries.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="absolute -bottom-[950px] left-0 w-full flex justify-center">
                  <a
                    href="https://zorbastays.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="text-[11px] tracking-[0.18em] text-gray-500 montserrat">
                      www.zorbastays.com
                    </span>
                  </a>
                </div>
              </div>
            </div>

            {/* ═══ PAGE 5 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
              <div className="w-full h-full flex flex-col relative">
                <div className="absolute -top-12 left-6 w-[1px] h-[220px] bg-gray-400"></div>
                <div className="flex flex-col items-end z-10 mt-24">
                  <input
                    type="text"
                    spellCheck={false}
                    placeholder="A private pool..."
                    value={formData.pooltitle || ""}
                    onChange={(e) => handleChange("pooltitle", e.target.value)}
                    onFocus={() => setActiveField("pooltitle")}
                    onBlur={() => setActiveField(null)}
                    maxLength={20}
                    className="waterfall text-7xl text-gray-900 bg-transparent outline-none text-right max-w-[90%] border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                  {activeField === "pooltitle" && (
                    <p className="text-xs text-gray-500">
                      {(formData.pooltitle || "").length}/20
                    </p>
                  )}
                </div>
                <div className="w-full flex flex-row space-x-4">
                  <div className="flex flex-col space-y-4 w-[65%]">
                    <ImageBox
                      imgKey="page5_1"
                      imgSrc={images["page5_1"]}
                      onOpen={openFilePicker}
                      onUpload={handleImageUpload}
                      inputRef={(el) => (fileInputRefs.current["page5_1"] = el)}
                      className="aspect-[16/12]"
                    />
                    <ImageBox
                      imgKey="page5_2"
                      imgSrc={images["page5_2"]}
                      onOpen={openFilePicker}
                      onUpload={handleImageUpload}
                      inputRef={(el) => (fileInputRefs.current["page5_2"] = el)}
                      className="aspect-[16/12]"
                    />
                  </div>
                  <ImageBox
                    imgKey="page5_3"
                    imgSrc={images["page5_3"]}
                    onOpen={openFilePicker}
                    onUpload={handleImageUpload}
                    inputRef={(el) => (fileInputRefs.current["page5_3"] = el)}
                    className="flex-1 h-[400px]"
                  />
                </div>
                <div className="absolute -bottom-40 w-full flex justify-center items-center space-x-4">
                  <div className="w-12 h-[1.5px] bg-gray-400"></div>
                  <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
                    <img
                      src="https://zorbastays.com/ZORBA_logo_iconGreen.webp"
                      alt="logo"
                      className="w-8 h-5 brightness-0"
                    />
                  </div>
                  <div className="w-12 h-[1.5px] bg-gray-400"></div>
                </div>
              </div>
            </div>

            {/* ═══ PAGE 6 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12 overflow-hidden">
              <div className="absolute top-0 right-0 w-[400px] h-[400px] opacity-5 pointer-events-none translate-x-5 -translate-y-5">
                <img
                  src="https://zorbastays.com/android-chrome-512x512.png"
                  alt="img"
                  className="w-full h-full object-contain grayscale"
                />
              </div>
              <div className="ml-1 mt-6 flex flex-col">
                <input
                  type="text"
                  placeholder="The"
                  value={formData.thetitle || ""}
                  onChange={(e) => handleChange("thetitle", e.target.value)}
                  onFocus={() => setActiveField("thetitle")}
                  onBlur={() => setActiveField(null)}
                  maxLength={10}
                  className="EBGaramond text-3xl text-gray-800 bg-transparent leading-tight outline-none max-w-[60%] 
                  border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                />
                {activeField === "thetitle" && (
                  <p className="text-xs text-gray-500">
                    {(formData.thetitle || "").length}/10
                  </p>
                )}
                <input
                  type="text"
                  placeholder="Living"
                  value={formData.livingtitle || ""}
                  onChange={(e) => handleChange("livingtitle", e.target.value)}
                  onFocus={() => setActiveField("livingtitle")}
                  onBlur={() => setActiveField(null)}
                  maxLength={15}
                  className="PlayfairDisplay text-4xl tracking-widest text-gray-800 uppercase bg-transparent outline-none max-w-[90%] 
                  border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                />
                {activeField === "livingtitle" && (
                  <p className="text-xs text-gray-500">
                    {(formData.livingtitle || "").length}/15
                  </p>
                )}
              </div>
              <div className="montserrat mt-6 w-full text-gray-600 tracking-wide text-[14px] leading-relaxed space-y-4">
                <div>
                  <textarea
                    placeholder="Start Writing..."
                    value={formData.livingdesc1 || ""}
                    onChange={(e) =>
                      handleChange("livingdesc1", e.target.value)
                    }
                    onFocus={() => setActiveField("livingdesc1")}
                    onBlur={() => setActiveField(null)}
                    maxLength={350}
                    rows={6}
                    className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                  {activeField === "livingdesc1" && (
                    <p className="text-xs text-gray-500 text-right">
                      {(formData.livingdesc1 || "").length}/350
                    </p>
                  )}
                </div>
                <div>
                  <textarea
                    placeholder="Start Writing..."
                    value={formData.livingdesc2 || ""}
                    onChange={(e) =>
                      handleChange("livingdesc2", e.target.value)
                    }
                    onFocus={() => setActiveField("livingdesc2")}
                    onBlur={() => setActiveField(null)}
                    maxLength={350}
                    rows={6}
                    className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                  {activeField === "livingdesc2" && (
                    <p className="text-xs text-gray-500 text-right">
                      {(formData.livingdesc2 || "").length}/350
                    </p>
                  )}
                </div>
              </div>
              <div
                className="absolute left-12 right-12 bottom-20 h-[460px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                onClick={() => openFilePicker("page6")}
              >
                {images.page6 ? (
                  <img
                    src={images.page6}
                    alt="Uploaded"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <ImgPlaceholder />
                )}
                <input
                  type="file"
                  accept="image/webp"
                  ref={(el) => (fileInputRefs.current["page6"] = el)}
                  onChange={(e) => handleImageUpload(e, "page6")}
                  className="hidden"
                />
              </div>
              <div className="absolute -bottom-16 left-12 flex gap-6">
                <div className="w-[1px] h-36 bg-gray-400"></div>
                <div className="w-[1px] h-36 bg-gray-400"></div>
              </div>
            </div>

            {/* ═══ PAGE 7 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
              <div className="w-full h-full flex flex-col relative pt-10 px-1">
                <div className="absolute top-4 right-1 z-20 flex flex-col items-end">
                  <input
                    type="text"
                    spellCheck={false}
                    placeholder="Kitchen & Dining "
                    value={formData.kitchentitle || ""}
                    onChange={(e) =>
                      handleChange("kitchentitle", e.target.value)
                    }
                    onFocus={() => setActiveField("kitchentitle")}
                    onBlur={() => setActiveField(null)}
                    maxLength={20}
                    className="waterfall text-7xl text-gray-900 bg-transparent outline-none text-right max-w-[100%] border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                  {activeField === "kitchentitle" && (
                    <p className="text-xs text-gray-500">
                      {(formData.kitchentitle || "").length}/20
                    </p>
                  )}
                </div>
                <div className="flex flex-col space-y-6 w-full pt-20">
                  <ImageBox
                    imgKey="page7_1"
                    imgSrc={images["page7_1"]}
                    onOpen={openFilePicker}
                    onUpload={handleImageUpload}
                    inputRef={(el) => (fileInputRefs.current["page7_1"] = el)}
                    className="h-[420px]"
                  />
                  <ImageBox
                    imgKey="page7_2"
                    imgSrc={images["page7_2"]}
                    onOpen={openFilePicker}
                    onUpload={handleImageUpload}
                    inputRef={(el) => (fileInputRefs.current["page7_2"] = el)}
                    className="h-[420px]"
                  />
                </div>
              </div>
            </div>

            {/* ═══ PAGE 8 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
              <div className="w-full h-full flex flex-col px-1 pt-0 relative">
                <div className="mb-8 ml-1 flex flex-col">
                  <input
                    type="text"
                    placeholder="The"
                    value={formData.thebedtitle || ""}
                    onChange={(e) =>
                      handleChange("thebedtitle", e.target.value)
                    }
                    onFocus={() => setActiveField("thebedtitle")}
                    onBlur={() => setActiveField(null)}
                    maxLength={10}
                    className="EBGaramond text-3xl text-gray-800 leading-tight mt-2 bg-transparent outline-none w-fit border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                  {activeField === "thebedtitle" && (
                    <p className="text-xs text-gray-500">
                      {(formData.thebedtitle || "").length}/10
                    </p>
                  )}
                  <input
                    type="text"
                    placeholder="BEDROOMS"
                    value={formData.bedroomtitle || ""}
                    onChange={(e) =>
                      handleChange("bedroomtitle", e.target.value)
                    }
                    onFocus={() => setActiveField("bedroomtitle")}
                    onBlur={() => setActiveField(null)}
                    maxLength={15}
                    className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2 bg-transparent outline-none w-fit border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                  {activeField === "bedroomtitle" && (
                    <p className="text-xs text-gray-500">
                      {(formData.bedroomtitle || "").length}/15
                    </p>
                  )}
                </div>
                <div className="montserrat mt-6 w-full text-gray-600 tracking-wide text-[14px] leading-relaxed space-y-4">
                  <div>
                    <textarea
                      placeholder="Start Writing..."
                      value={formData.beddesc1 || ""}
                      onChange={(e) => handleChange("beddesc1", e.target.value)}
                      onFocus={() => setActiveField("beddesc1")}
                      onBlur={() => setActiveField(null)}
                      maxLength={350}
                      rows={6}
                      className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                    />
                    {activeField === "beddesc1" && (
                      <p className="text-xs text-gray-500 text-right">
                        {(formData.beddesc1 || "").length}/350
                      </p>
                    )}
                  </div>
                  <div>
                    <textarea
                      placeholder="Start Writing..."
                      value={formData.beddesc2 || ""}
                      onChange={(e) => handleChange("beddesc2", e.target.value)}
                      onFocus={() => setActiveField("beddesc2")}
                      onBlur={() => setActiveField(null)}
                      maxLength={300}
                      rows={5}
                      className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                    />
                    {activeField === "beddesc2" && (
                      <p className="text-xs text-gray-500 text-right">
                        {(formData.beddesc2 || "").length}/300
                      </p>
                    )}
                  </div>
                </div>
                <ImageBox
                  imgKey="page8"
                  imgSrc={images["page8"]}
                  onOpen={openFilePicker}
                  onUpload={handleImageUpload}
                  inputRef={(el) => (fileInputRefs.current["page8"] = el)}
                  className="mt-5 w-full h-[450px]"
                />
                <div className="absolute -bottom-12 left-0 w-full flex justify-center items-center space-x-4">
                  <div className="w-12 h-[1px] bg-gray-400"></div>
                  <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
                    <img
                      src="https://zorbastays.com/ZORBA_logo_iconGreen.webp"
                      alt="Logo"
                      className="w-7 h-5 brightness-0 opacity-70"
                    />
                  </div>
                  <div className="w-12 h-[1px] bg-gray-400"></div>
                </div>
              </div>
            </div>

            {/* ═══ PAGE 9 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
              <div className="w-full h-full flex flex-col relative pt-16 px-1">
                <div className="flex flex-col space-y-6 w-full">
                  <ImageBox
                    imgKey="page9_1"
                    imgSrc={images["page9_1"]}
                    onOpen={openFilePicker}
                    onUpload={handleImageUpload}
                    inputRef={(el) => (fileInputRefs.current["page9_1"] = el)}
                    className="h-[450px]"
                  />
                  <ImageBox
                    imgKey="page9_2"
                    imgSrc={images["page9_2"]}
                    onOpen={openFilePicker}
                    onUpload={handleImageUpload}
                    inputRef={(el) => (fileInputRefs.current["page9_2"] = el)}
                    className="h-[420px]"
                  />
                </div>
              </div>
            </div>

            {/* button 1*/}
            {dynamicPages1.map((page) => renderDynamicLayout(page))}

            <div className="flex items-center justify-between w-full max-w-[800px]">
              <div>
                {dynamicPages1.length > 0 && (
                  <button
                    onClick={() => {
                      const confirmChange = window.confirm(
                        "Are you sure you want to change layout?",
                      );

                      if (confirmChange) {
                        const lastPage =
                          dynamicPages1[dynamicPages1.length - 1];
                        setEditingPageId(lastPage.id);
                        setShowLayoutPopup(true);
                      }
                    }}
                    className="border border-green-700 text-green-700 px-4 py-2 rounded-full font-semibold hover:scale-95 transition-all ease-linear duration-200"
                  >
                    Change Layout
                  </button>
                )}
              </div>
              <div className="">
                <button
                  onClick={() => openPopup("afterPage9")}
                  className="bg-green-800 text-white px-6 py-2 rounded-full font-semibold hover:scale-95 transition-all ease-linear duration-200"
                >
                  + Add Page
                </button>
              </div>
            </div>

            {/* --- LAYOUT SELECTION POPUP --- */}
            {showLayoutPopup && (
              <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-[100] p-5">
                <div className="bg-white rounded-2xl p-8 max-w-3xl w-full">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">
                      Choose a Layout
                    </h2>
                    <button onClick={() => setShowLayoutPopup(false)}>
                      <IoMdClose size={28} />
                    </button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div
                      onClick={() => {
                        if (editingPageId) {
                          handleLayoutChangeFromPopup("layout1");
                        } else {
                          addLayoutPage("layout1");
                        }
                      }}
                      className="cursor-pointer group"
                    >
                      <div className="border-2 border-gray-200 rounded-lg p-2 group-hover:border-green-600 transition-all">
                        <div className="bg-gray-100 h-40 flex flex-col gap-2 p-2">
                          <div className="bg-gray-300 h-1/2 w-full rounded"></div>
                          <div className="bg-gray-300 h-1/2 w-full rounded"></div>
                        </div>
                      </div>
                      <p className="text-center mt-3 font-medium">Layout 1</p>
                    </div>

                    <div
                      onClick={() => {
                        if (editingPageId) {
                          handleLayoutChangeFromPopup("layout2");
                        } else {
                          addLayoutPage("layout2");
                        }
                      }}
                      className="cursor-pointer group"
                    >
                      <div className="border-2 border-gray-200 rounded-lg p-2 group-hover:border-green-600 transition-all">
                        <div className="bg-gray-100 h-40 flex flex-col gap-2 p-2">
                          <div className="bg-gray-300 h-[45%] w-full rounded"></div>
                          <div className="flex gap-2 h-[45%]">
                            <div className="bg-gray-300 flex-1 rounded"></div>
                            <div className="bg-gray-300 flex-1 rounded"></div>
                          </div>
                        </div>
                      </div>
                      <p className="text-center mt-3 font-medium">Layout 2</p>
                    </div>

                    <div
                      onClick={() => {
                        if (editingPageId) {
                          handleLayoutChangeFromPopup("layout3");
                        } else {
                          addLayoutPage("layout3");
                        }
                      }}
                      className="cursor-pointer group"
                    >
                      <div className="border-2 border-gray-200 rounded-lg p-2 group-hover:border-green-600 transition-all">
                        <div className="bg-gray-100 h-40 flex flex-col gap-2 p-2">
                          <div className="bg-gray-300 h-[45%] w-full rounded"></div>
                          <div className="flex gap-2 h-[45%] items-start">
                            <div className="bg-gray-300 flex-1 h-[70%] rounded"></div>
                            <div className="bg-gray-300 flex-1 h-full rounded"></div>
                          </div>
                        </div>
                      </div>
                      <p className="text-center mt-3 font-medium">Layout 3</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ═══ PAGE 15 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-10">
              <div className="w-full h-full flex flex-col relative pt-10 px-1">
                <div className="absolute top-0 left-6 z-20 flex items-center w-full">
                  <input
                    type="text"
                    spellCheck={false}
                    placeholder="Common Areas"
                    value={formData.commonareas || ""}
                    onChange={(e) =>
                      handleChange("commonareas", e.target.value)
                    }
                    onFocus={() => setActiveField("commonareas")}
                    onBlur={() => setActiveField(null)}
                    maxLength={14}
                    className="waterfall text-7xl text-gray-800 -ml-6 p-1 bg-transparent outline-none w-auto min-w-[350px] max-w-[800px] border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                    style={{
                      width: `${Math.max(200, (formData.commonareas?.length || 14) * 22)}px`,
                    }}
                  />
                  {activeField === "commonareas" && (
                    <p className="absolute left-72 -bottom-5 text-xs text-gray-500 whitespace-nowrap">
                      {(formData.commonareas || "").length}/14
                    </p>
                  )}
                  <div className="flex-1 h-[1px] bg-gray-400"></div>
                </div>
                <div className="absolute top-24 left-3 w-[1px] h-[970px] bg-gray-400"></div>
                <div className="flex flex-col space-y-4 w-full h-[950px] pt-28 pl-16">
                  <ImageBox
                    imgKey="page15_1"
                    imgSrc={images["page15_1"]}
                    onOpen={openFilePicker}
                    onUpload={handleImageUpload}
                    inputRef={(el) => (fileInputRefs.current["page15_1"] = el)}
                    className="flex-1"
                  />
                  <ImageBox
                    imgKey="page15_2"
                    imgSrc={images["page15_2"]}
                    onOpen={openFilePicker}
                    onUpload={handleImageUpload}
                    inputRef={(el) => (fileInputRefs.current["page15_2"] = el)}
                    className="flex-1"
                  />
                </div>
              </div>
            </div>

            {/* ═══ PAGE 16 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
              <div className="w-full h-full flex flex-col relative pt-16 px-1">
                <div className="flex flex-col space-y-6 w-full">
                  <ImageBox
                    imgKey="page16_1"
                    imgSrc={images["page16_1"]}
                    onOpen={openFilePicker}
                    onUpload={handleImageUpload}
                    inputRef={(el) => (fileInputRefs.current["page16_1"] = el)}
                    className="h-[450px]"
                  />
                  <ImageBox
                    imgKey="page16_2"
                    imgSrc={images["page16_2"]}
                    onOpen={openFilePicker}
                    onUpload={handleImageUpload}
                    inputRef={(el) => (fileInputRefs.current["page16_2"] = el)}
                    className="h-[420px]"
                  />
                </div>
              </div>
            </div>

            {/* button 2 */}
            {dynamicPages2.map((page) => renderDynamicLayout(page))}

            <div className="flex items-center justify-between w-full max-w-[800px]">
              <div>
                {" "}
                {dynamicPages2.length > 0 && (
                  <button
                    onClick={() => {
                      const confirmChange = window.confirm(
                        "Are you sure you want to change layout?",
                      );

                      if (confirmChange) {
                        const lastPage =
                          dynamicPages2[dynamicPages2.length - 1];
                        setEditingPageId(lastPage.id);
                        setShowLayoutPopup(true);
                      }
                    }}
                    className="border border-green-700 text-green-700 px-6 py-2 rounded-full font-semibold hover:scale-95 transition-all ease-linear duration-200"
                  >
                    Change Layout
                  </button>
                )}
              </div>
              <div className="">
                <button
                  onClick={() => openPopup("afterPage16")}
                  className="bg-green-800 text-white px-6 py-2 rounded-full font-semibold hover:scale-95 transition-all ease-linear duration-200"
                >
                  + Add Page
                </button>
              </div>
            </div>

            {/* ═══ PAGE 21 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
              <div className="w-full h-full flex flex-col px-1 pt-16 relative">
                <div className="mb-12">
                  <input
                    type="text"
                    spellCheck={false}
                    placeholder="Feel Every destination"
                    value={formData.destination || ""}
                    onChange={(e) =>
                      handleChange("destination", e.target.value)
                    }
                    onFocus={() => setActiveField("destination")}
                    onBlur={() => setActiveField(null)}
                    maxLength={30}
                    className="text-4xl PlayfairDisplay text-gray-800 bg-transparent outline-none w-full border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                  {activeField === "destination" && (
                    <p className="text-xs text-gray-500">
                      {(formData.destination || "").length}/30
                    </p>
                  )}
                  <textarea
                    placeholder="Start Writing..."
                    value={formData.destinationdesc || ""}
                    onChange={(e) =>
                      handleChange("destinationdesc", e.target.value)
                    }
                    onFocus={() => setActiveField("destinationdesc")}
                    onBlur={() => setActiveField(null)}
                    maxLength={450}
                    rows={7}
                    className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:ring-0 mt-5 focus:border-black transition-all duration-300"
                  />
                  {activeField === "destinationdesc" && (
                    <p className="text-xs text-gray-500 text-right">
                      {(formData.destinationdesc || "").length}/450
                    </p>
                  )}
                  <div className="relative w-full h-40 mt-5 overflow-hidden rounded-sm flex flex-col items-center justify-center gap-3">
                    <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
                    <div className="relative z-10 w-[80%] text-center">
                      <input
                        type="text"
                        spellCheck={false}
                        placeholder="Check Travel Guide for Your Stay"
                        value={formData.traveltitle || ""}
                        onChange={(e) =>
                          handleChange("traveltitle", e.target.value)
                        }
                        onFocus={() => setActiveField("traveltitle")}
                        onBlur={() => setActiveField(null)}
                        maxLength={40}
                        className="text-2xl font-bold text-gray-800 bg-transparent outline-none text-center w-full border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                      />
                      {activeField === "traveltitle" && (
                        <p className="text-xs text-gray-500 mt-1">
                          {(formData.traveltitle || "").length}/40
                        </p>
                      )}
                    </div>
                    <div className="relative z-10 w-auto text-center">
                      <input
                        type="text"
                        placeholder="Add link"
                        value={formData.travellink || ""}
                        onChange={(e) =>
                          handleChange("travellink", e.target.value)
                        }
                        onFocus={() => setActiveField("travellink")}
                        onBlur={() => setActiveField(null)}
                        className="text-sm px-3 py-1 bg-black text-white text-center print:hidden border border-transparent focus:ring-0 focus:border-white transition-all duration-300 outline-none"
                      />
                      <p className="hidden print:block text-sm px-3 py-1 bg-black text-white text-center">
                        {formData.travellink || "Add Link"}
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <input
                    type="text"
                    spellCheck={false}
                    placeholder="Concierge at Your service"
                    value={formData.service || ""}
                    onChange={(e) => handleChange("service", e.target.value)}
                    onFocus={() => setActiveField("service")}
                    onBlur={() => setActiveField(null)}
                    maxLength={30}
                    className="text-4xl PlayfairDisplay text-gray-800 bg-transparent outline-none w-full border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                  {activeField === "service" && (
                    <p className="text-xs text-gray-500">
                      {(formData.service || "").length}/30
                    </p>
                  )}
                  <textarea
                    placeholder="Start Writing..."
                    value={formData.servicedesc || ""}
                    onChange={(e) =>
                      handleChange("servicedesc", e.target.value)
                    }
                    onFocus={() => setActiveField("servicedesc")}
                    onBlur={() => setActiveField(null)}
                    maxLength={450}
                    rows={7}
                    className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:ring-0 mt-5 focus:border-black transition-all duration-300"
                  />
                  {activeField === "servicedesc" && (
                    <p className="text-xs text-gray-500 text-right">
                      {(formData.servicedesc || "").length}/450
                    </p>
                  )}
                  <div className="relative w-full h-40 mt-5 overflow-hidden rounded-sm flex flex-col items-center justify-center gap-3">
                    <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
                    <div className="relative z-10 w-[80%] text-center">
                      <input
                        type="text"
                        spellCheck={false}
                        placeholder="Explore Concierge services"
                        value={formData.conciergetitle || ""}
                        onChange={(e) =>
                          handleChange("conciergetitle", e.target.value)
                        }
                        onFocus={() => setActiveField("conciergetitle")}
                        onBlur={() => setActiveField(null)}
                        maxLength={40}
                        className="text-2xl font-bold text-gray-800 bg-transparent outline-none text-center w-full border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                      />
                      {activeField === "conciergetitle" && (
                        <p className="text-xs text-gray-500 mt-1">
                          {(formData.conciergetitle || "").length}/40
                        </p>
                      )}
                    </div>
                    <div className="relative z-10 w-auto text-center">
                      <input
                        type="text"
                        placeholder="Add link"
                        value={formData.conciergelink || ""}
                        onChange={(e) =>
                          handleChange("conciergelink", e.target.value)
                        }
                        onFocus={() => setActiveField("conciergelink")}
                        onBlur={() => setActiveField(null)}
                        className="text-sm px-3 py-1 bg-black text-white text-center print:hidden border border-transparent focus:ring-0 focus:border-white transition-all duration-300 outline-none"
                      />
                      <p className="hidden print:block text-sm px-3 py-1 bg-black text-white text-center">
                        {formData.conciergelink || "Add Link"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ═══ PAGE 22 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
              <div className="w-full h-full flex flex-col relative pt-10 px-8">
                <div className="absolute top-10 right-12 z-20 flex items-center justify-end w-full">
                  <div className="flex-1 h-[1px] bg-gray-400"></div>
                  <span className="waterfall text-8xl text-gray-800 pl-6">
                    About Zorba
                  </span>
                </div>
                <div className="absolute top-32 -bottom-12 right-12 w-[1.5px] bg-gray-400"></div>
                <div className="flex flex-col justify-center h-full max-w-[95%] pr-16 pl-8 pt-[350px]">
                  <input
                    type="text"
                    spellCheck={false}
                    placeholder="Find your self in nature."
                    value={formData.nature || ""}
                    onChange={(e) => handleChange("nature", e.target.value)}
                    onFocus={() => setActiveField("nature")}
                    onBlur={() => setActiveField(null)}
                    maxLength={25}
                    className="text-4xl PlayfairDisplay text-gray-800 mb-1 bg-transparent outline-none border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                  />
                  {activeField === "nature" && (
                    <p className="text-xs text-gray-500">
                      {(formData.nature || "").length}/25
                    </p>
                  )}
                  <div
                    className="montserrat flex flex-col space-y-3 text-gray-800 text-[15px] tracking-widest text-justify"
                    style={{ wordSpacing: "1px" }}
                  >
                    <textarea
                      placeholder="Start Writing..."
                      value={formData.naturedesc1 || ""}
                      onChange={(e) =>
                        handleChange("naturedesc1", e.target.value)
                      }
                      onFocus={() => setActiveField("naturedesc1")}
                      onBlur={() => setActiveField(null)}
                      maxLength={350}
                      rows={8}
                      className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:ring-0 mt-3 focus:border-black transition-all duration-300"
                    />
                    {activeField === "naturedesc1" && (
                      <p className="text-xs text-gray-500 text-right">
                        {(formData.naturedesc1 || "").length}/350
                      </p>
                    )}
                    <textarea
                      placeholder="Start Writing..."
                      value={formData.naturedesc2 || ""}
                      onChange={(e) =>
                        handleChange("naturedesc2", e.target.value)
                      }
                      onFocus={() => setActiveField("naturedesc2")}
                      onBlur={() => setActiveField(null)}
                      maxLength={350}
                      rows={6}
                      className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                    />
                    {activeField === "naturedesc2" && (
                      <p className="text-xs text-gray-500 text-right">
                        {(formData.naturedesc2 || "").length}/350
                      </p>
                    )}
                    <textarea
                      placeholder="Start Writing..."
                      value={formData.naturedesc3 || ""}
                      onChange={(e) =>
                        handleChange("naturedesc3", e.target.value)
                      }
                      onFocus={() => setActiveField("naturedesc3")}
                      onBlur={() => setActiveField(null)}
                      maxLength={300}
                      rows={7}
                      className="w-full bg-transparent outline-none resize-none p-2 border border-transparent focus:ring-0 focus:border-black transition-all duration-300"
                    />
                    {activeField === "naturedesc3" && (
                      <p className="text-xs text-gray-500 text-right">
                        {(formData.naturedesc3 || "").length}/300
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* ═══ PAGE 23 ═══ */}
            <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative p-12">
              <div className="w-full h-full flex flex-col justify-between items-center py-24 px-12">
                <div className="flex flex-col items-center mt-60">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public"
                    alt="Zorba Stays"
                    className="h-44 w-auto object-contain brightness-0"
                  />
                </div>
                <div className="absolute bottom-3 items-center space-y-32">
                  <div className="text-center">
                    <span className="waterfall text-8xl block">
                      Indulge in the extraordinary;
                    </span>
                    <span className="waterfall text-7xl block">
                      life's too short for ordinary
                    </span>
                  </div>
                  <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
                    <a
                      href="https://zorbastays.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>www.zorbastays.com</span>
                    </a>
                    <span className="h-3 w-[1px] bg-gray-400"></span>
                    <a href="mailto:info@zorbastays.com">
                      <span>info@zorbastays.com</span>
                    </a>
                    <span className="h-3 w-[1px] bg-gray-400"></span>
                    <span>63552-31066, 98750-28066</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* BUTTONS */}
          {/* <div className="flex justify-center mt-8">
            <div className="grid grid-cols-2 gap-3 w-full max-w-xs">
              <button className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm">
                Cancel
              </button>

              <button
                onClick={handleSave}
                className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
              >
                Save
              </button>
            </div>
          </div> */}
          {/* BUTTONS */}
          <div className="flex justify-center mt-8">
            <div className="grid grid-cols-2 gap-3 w-full max-w-xs">
              <button
                onClick={() => navigate("/PropertyBrochure")}
                disabled={isSaving}
                className={`px-6 z-30 py-2 rounded-lg text-center text-white relative overflow-hidden transition-all duration-700 text-sm ${
                  isSaving
                    ? "bg-gray-500 cursor-not-allowed opacity-60"
                    : "bg-gray-800 hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700"
                }`}
              >
                Cancel
              </button>

              <button
                onClick={handleSave}
                disabled={isSaving}
                className={`px-6 z-30 py-2 rounded-lg text-center text-white relative overflow-hidden transition-all duration-700 text-sm flex items-center justify-center gap-2 ${
                  isSaving
                    ? "bg-green-600 cursor-not-allowed opacity-60"
                    : "bg-green-900 hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700"
                }`}
              >
                {isSaving ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></div>
                    Creating...
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>

          {/* Loading Overlay */}
          {isSaving && (
            <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center">
              <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4 text-center shadow-2xl transform transition-all">
                <div className="mb-6">
                  <div className="inline-block">
                    <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-green-600"></div>
                  </div>
                </div>

                <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                  Creating Brochure
                </h3>

                <p className="text-gray-600 mb-4 text-base">
                  Please wait while we create your brochure. This may take 2-5
                  minutes depending on image sizes.
                </p>

                <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 overflow-hidden">
                  <div
                    className="bg-green-600 h-2.5 rounded-full animate-pulse"
                    style={{ width: "100%" }}
                  ></div>
                </div>

                <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
                  <div
                    className="w-2 h-2 bg-green-600 rounded-full animate-bounce"
                    style={{ animationDelay: "0s" }}
                  ></div>
                  <div
                    className="w-2 h-2 bg-green-600 rounded-full animate-bounce"
                    style={{ animationDelay: "0.2s" }}
                  ></div>
                  <div
                    className="w-2 h-2 bg-green-600 rounded-full animate-bounce"
                    style={{ animationDelay: "0.4s" }}
                  ></div>
                  <span className="ml-2">Processing your request...</span>
                </div>

                <p className="text-xs text-gray-400 mt-4">
                  Please don't close or refresh this page
                </p>
              </div>
            </div>
          )}

          {/* Disable scrolling and interactions when saving */}
          {isSaving && (
            <style>
              {`
      body {
        overflow: hidden !important;
      }
      
      button, input, select, textarea, a, [role="button"], .cursor-pointer {
        pointer-events: none !important;
      }
      
      .fixed {
        pointer-events: auto !important;
      }
      
      .fixed button, .fixed .pointer-events-auto {
        pointer-events: auto !important;
      }
    `}
            </style>
          )}
        </div>
      </main>
    </div>
  );
};

export default BrochureElementor;
